import i18n from 'modules/core/lib/i18n'

import { Role } from 'modules/contracts/hooks/useLegalEntityRoles'
import Selector from 'modules/employees/components/Selector'

interface Props {
  onRoleSelect: (value: number | undefined) => void
  selectedRole: number | undefined
  roles: Role[]
  error?: string
  createJob: (value: string) => Promise<void>
  onToggle?: (isOpen: boolean) => void
  isOpen?: boolean
  canCreate?: boolean
}

const rolesOptions = (roles: Role[]) => {
  return roles.map((role: Role) => {
    const { id, name } = role

    return (
      <Selector.Option key={id} value={id} label={name} searchValue={name}>
        {name}
      </Selector.Option>
    )
  })
}

const RolesSelect = ({
  onRoleSelect,
  selectedRole,
  roles,
  error,
  createJob,
  onToggle,
  isOpen,
  canCreate = true,
}: Props) => {
  return (
    <Selector.Popover
      label={i18n.t('employee_form.wizard.role_step.role_selector.label')}
      value={selectedRole ? [selectedRole] : []}
      onChange={(value) => onRoleSelect(value ? +value : undefined)}
      placeholder={i18n.t('employee_form.wizard.role_step.role_selector.placeholder')}
      actionLabel={i18n.t('employee_form.wizard.role_step.role_selector.action_label')}
      blankAction={createJob}
      error={error}
      onToggle={onToggle}
      isOpen={isOpen}
      canCreate={canCreate}
    >
      {rolesOptions(roles)}
    </Selector.Popover>
  )
}

export default RolesSelect
